import { Nullable } from 'vitest';

import { genesisAirdropControllerApi } from '../../clients/clients';
import { GetTeamGenesisAirdropLeaderboardRequest } from '../../generated';

export type TeamLeaderboardParam = {
  epoch: Nullable<GetTeamGenesisAirdropLeaderboardRequest['epoch']>;
  page: number;
  size: number;
};

const getKey = (params: TeamLeaderboardParam) => {
  return ['genesisAirdropControllerApi', 'teamBoostHistoryParam', params];
};
const getFn =
  ({ ...params }: TeamLeaderboardParam) =>
  async () => {
    if (!params.epoch) {
      throw new Error('Query should not be called');
    }

    return genesisAirdropControllerApi.getTeamGenesisAirdropLeaderboard({
      epoch: params.epoch,
      page: params.page,
      size: params.size,
    });
  };

export const teamLeaderboardQuery = {
  getKey,
  getFn,
};
